import { Box } from "@mui/material";
import { useState, useEffect } from "react";
import { ShippingGroupPreview } from "./ShippingGroupPreview";
import { UserInputUpdateType } from "../../CheckoutMachine/types/CheckoutMachine";
import { useCheckoutContext } from "../../CheckoutMachine/CheckoutProvider";
import { useOrder } from "../../OrderProvider";
import { ChevronDownIcon } from "@brandclub/common-ui";
import { ShoppingCartItem } from "../../types";
import { SummaryProduct } from "../SummaryProduct";
import { useSelector } from "@xstate/react";

export const getErrorProducts = (items: ShoppingCartItem[]) => {
  let res: ShoppingCartItem[] = items;
  res = res.filter(
    (item) => item.status === "error" && item?.userApprovalStatus !== "deleted"
  );
  return res;
};

const DeliverySection = () => {
  const { openDelivery: open, setOpenDelivery: setOpen } = useOrder();
  const { actorRef, send: checkoutSend } = useCheckoutContext();
  const userRetailerCheckoutOrder = useSelector(
    actorRef,
    (snapshot) =>
      snapshot.context.retailerCheckoutOrderStatus?.userRetailerCheckoutOrder
  );
  const shippingGroups =
    userRetailerCheckoutOrder?.shippingOptions?.shippingGroups;
  const [openOptions, setOpenOptions] = useState<boolean[]>([]);

  const toggleOpen = () => {
    setOpen(!open);
  };

  useEffect(() => {
    const length = shippingGroups?.length ?? 0;
    setOpenOptions(new Array(length).fill(open));
  }, [open, shippingGroups?.length]);

  const items = userRetailerCheckoutOrder?.items;

  const errorProducts = getErrorProducts(items ?? []);

  const handleUpdateShippingOption = async (
    deliveryOption?: {
      name: string;
      cssSelector: string;
    },
    deliveryTimeWindow?: {
      name: string;
      cssSelector: string;
    }
  ) => {
    try {
      checkoutSend({
        type: "CHECKOUT_USER_INPUT_EVENT",
        inputEvent: UserInputUpdateType.UPDATE_SHIPPING_OPTION,
        data: {
          deliveryOption,
          deliveryTimeWindow,
        },
      });
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <Box className="section">
      <div
        className="section_head"
        style={{ cursor: "pointer" }}
        onClick={() => toggleOpen()}
      >
        <div className="title">Delivery</div>
        <ChevronDownIcon
          style={{
            transition: "transform 0.3s",
            width: "33px",
            height: "33px",
            transform: open ? "rotate(180deg)" : "rotate(0deg)",
          }}
        ></ChevronDownIcon>
      </div>
      <div className="shipping_group_list">
        {shippingGroups?.map((e, index) => {
          return (
            <ShippingGroupPreview
              key={index}
              shippingGroup={e}
              index={index}
              handleUpdateShippingOption={handleUpdateShippingOption}
              deliveryOpen={openOptions}
              openItem={(index: number) => {
                const newOpenOptions = [...openOptions];
                newOpenOptions[index] = !newOpenOptions[index];
                setOpenOptions(newOpenOptions);
              }}
            />
          );
        })}
        {errorProducts.length > 0 ? (
          <>
            {errorProducts.map((errorProduct) => {
              return (
                <SummaryProduct
                  product={errorProduct}
                  key={errorProduct.stacklineSku}
                />
              );
            })}
          </>
        ) : null}
      </div>
    </Box>
  );
};

export default DeliverySection;
